import script from "./home-base.vue?vue&type=script&setup=true&lang=js"
export * from "./home-base.vue?vue&type=script&setup=true&lang=js"

import "./home-base.vue?vue&type=style&index=0&id=43fa4265&scoped=true&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43fa4265"]])

export default __exports__